{
  "users": {
    "navigation_title": "Users",
    "title": "Users",
    "list": {
      "title": "List",
      "delete": {
        "itself": "Sorry. You can not delete yourself"
      }
    },
    "edit": "Edit Profile",
    "filter_input": "Filter users...",
    "invitations_filter_input": "Filter invitations...",
    "edit_profile": "Edit Profile",
    "profile_title": "Profile",
    "notifications": "Notifications",
    "access": "Access",
    "reset_password": "Reset Password",
    "form_title": "User",
    "create_new": "New User",
    "save": "Save",
    "go_to_index": "Back To Users",
    "error_settings": "Please review your settings!",
    "user_password_succesfull_update": "Your password has been changed",
    "remove_role": "Delete Role",
    "remove_user_role_confirmation": {
      "text": "You are about to delete %{role} role at %{name} for %{email}. Are you sure you want to continue?",
      "cancel": "Cancel",
      "confirm": "Confirm"
    },
    "remove_role_confirmation": {
      "text": "You are about to delete %{role} role at %{name}. Are you sure you want to continue?",
      "cancel": "Cancel",
      "confirm": "Confirm"
    },
    "delete_user": "Delete User",
    "delete_user_confirmation": {
      "text": "You are about to permanently delete %{email}. Are you sure you want to continue?"
    },
    "organization_roles": "Organization Roles",
    "project_roles": "Project Roles",
    "add_role": "Add role",
    "roles_title": "Access",
    "manage_roles": "Manage Roles",
    "user_details": "User Details",
    "invite_new_user": "Invite User",
    "sent_invitation": "Sent Invitations",
    "save_roles": "Save roles",
    "select_user": "Select User",
    "admin_user": "This user is an admin",
    "support_user": "This user is a support user",
    "organization_levels": {
      "executive": "Executive",
      "director": "Director",
      "manager": "Manager",
      "sales": "Sales",
      "technical": "Technical"
    },
    "states": {
      "online": "Online",
      "offline": "Offline"
    },
    "notices": {
      "email_digest": "Email Digest",
      "email": "Email",
      "sms": "SMS",
      "email_sms": "Email + SMS",
      "critical_level": "Critical Level",
      "warning_level": "Warning Level",
      "info_level": "Info Level",
      "alert": "Alert",
      "message": "Message",
      "organization_request": "Organization Request",
      "membership": "Membership"
    },
    "roles": {
      "manager": "Manager",
      "manager_at": "Manager at %{org_name}",
      "user": "User",
      "user_at": "User at %{org_name}",
      "owner": "Owner",
      "owner_at": "Owner at %{org_name}",
      "support": "Support",
      "accountant": "Accountant",
      "accountant_at": "Accountant at %{org_name}",
      "admin": "Admin",
      "admin_at": "Admin at %{org_name}",
      "default_option": "Choose role.."
    },
    "notifying_methods": {
      "email": "Email",
      "sms": "SMS"
    },
    "notifying_types": {
      "formation_request": "New Organization Request",
      "message": "Message",
      "partnership": "Organization Partnership",
      "membership": "Organization Membership",
      "alert": "Alert"
    },
    "notifying_levels": {
      "critical": "Critical",
      "warning": "Warning",
      "info": "Info"
    },
    "more_info": {
      "contact_info": "Contact Info",
      "office": "Office",
      "mobile": "Mobile",
      "company_address": "Company Address",
      "language": "Language"
    },
    "grid": {
      "qr_code": "Qr Code",
      "user_picture": "User Picture"
    },
    "access_form": {
      "title": "Access",
      "organization": "Organization",
      "role": "Role",
      "remove": "Remove from organization",
      "undo": "Undo",
      "locked": "Only an owner can change a %{role}",
      "no_roles": "No organization roles.",
      "save": "Save changes",
      "saved": "Access saved",
      "failed": "Some changes weren't saved. They're still on the page.",
      "manage_access": "Manage access",
      "not_found": "This user isn't in your organizations."
    }
  }
}
